/* eslint-disable */
export default {
  noRecords: 'Viimeaikaisia tallenteita ei löytynyt.',
} as const;

// @key: @#@"noRecords"@#@ @source: @#@"No recent records found."@#@
